angular.module('am4').directive('onFilesChange', () => {
    return {
        restrict: 'A',
        bindToController: {
            onFilesChange: '&'
        },
        controller: function($element, $scope) {
            const onChange = () => {
                this.onFilesChange({ files: $element[0].files });
            };

            $element[0].addEventListener('change', onChange);

            $scope.$on('$destroy', () => {
                $element[0].removeEventListener('change', onChange);
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/onFilesChange.js